import React from 'react';
import { CopilotChat } from "@copilotkit/react-ui";

const CopilotChatPage = () => {
  return (
    <div className="container h-screen p-4 mx-auto">
      <div className="h-full">
        <CopilotChat
          instructions={"You are a helpful AI agent. You can assist with various tasks and questions. Please be concise and helpful in your responses."}
          labels={{
            title: "AI Agent Assistant",
            initial: "Hi! 👋 I'm your AI agent. How can I help you today?",
            placeholder: "Ask me anything...",
          }}
        />
      </div>
    </div>
  );
};

export default CopilotChatPage;
